import * as React from "react"
import {SvgFunction} from "@web-libs/ui/svgs/types";
import {withClick} from "@web-libs/ui/svgs/clickable/with-click";
import {withColor} from "@web-libs/ui/svgs/fill/with-color";
const _CloseIcon: SvgFunction = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
        width={props.width ?? 14}
        height={props.height ?? 14}
    >
        <path
            fill={props.fill}
            d="M12.657 10.771 8.886 7l3.77-3.771a1.334 1.334 0 0 0-1.885-1.886L7 5.114l-3.771-3.77a1.333 1.333 0 1 0-1.886 1.885L5.114 7l-3.77 3.771a1.333 1.333 0 0 0 1.885 1.886L7 8.886l3.771 3.77a1.333 1.333 0 1 0 1.886-1.885Z"
        />
    </svg>
)

const CloseIcon = withColor(_CloseIcon)
export default CloseIcon
